// extracted by mini-css-extract-plugin
export default {"widgetCardsWrapper":"ChangeSummary_widgetCardsWrapper__01nfF"};